import React, { useEffect } from 'react';
import ReactDOM from 'react-dom';

const LogoutModal = ({ isOpen, onClose, onConfirm }) => {
    useEffect(() => {
        if (isOpen) {
            document.body.style.overflow = 'hidden';
            document.documentElement.style.overflow = 'hidden';
        } else {
            document.body.style.overflow = '';
            document.documentElement.style.overflow = '';
        }
        return () => {
            document.body.style.overflow = '';
            document.documentElement.style.overflow = '';
        };
    }, [isOpen]);

    if (!isOpen) return null;

    const handleBackdropClick = (e) => {
        if (e.target === e.currentTarget) onClose();
    };

    return ReactDOM.createPortal(
        <div
            className="fixed inset-0 z-[9999] flex items-center justify-center p-4 bg-black/50 backdrop-blur-sm transition-opacity animate-in fade-in duration-300"
            onClick={handleBackdropClick}
            style={{ position: 'fixed', top: 0, left: 0, right: 0, bottom: 0 }}
        >
            <div className="bg-white w-full max-w-[400px] rounded-[32px] shadow-2xl relative overflow-hidden animate-in zoom-in-95 duration-300 p-8 flex flex-col items-center text-center">
                {/* Question Icon */}
                <div className="w-20 h-20 rounded-full border-4 border-[#EF4444] flex items-center justify-center mb-6 text-[#EF4444]">
                    <svg xmlns="http://www.w3.org/2000/svg" width="40" height="40" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="3" strokeLinecap="round" strokeLinejoin="round"><circle cx="12" cy="12" r="10"></circle><path d="M9.09 9a3 3 0 0 1 5.83 1c0 2-3 3-3 3"></path><line x1="12" y1="17" x2="12.01" y2="17"></line></svg>
                </div>

                <h2 className="text-2xl font-bold text-gray-900 mb-3">Anda Yakin Ingin Keluar?</h2>
                <p className="text-gray-500 font-body text-sm leading-relaxed mb-8">
                    Anda akan keluar dari akun dan perlu login kembali untuk melanjutkan.
                </p>

                <div className="flex gap-3 w-full">
                    <button
                        onClick={onConfirm}
                        className="flex-1 py-3.5 bg-[#EF4444] text-white font-bold rounded-full hover:bg-red-600 transition-all shadow-lg shadow-red-500/30 active:scale-[0.98]"
                    >
                        Ya, keluar
                    </button>
                    <button
                        onClick={onClose}
                        className="flex-1 py-3.5 bg-gray-200 text-gray-700 font-bold rounded-full hover:bg-gray-300 transition-all active:scale-[0.98]"
                    >
                        Tidak
                    </button>
                </div>
            </div>
        </div>,
        document.body
    );
};

export default LogoutModal;
